import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhInputSwitchComponent } from './components/fh-input-switch.component';
import { FhLabelModule } from '@fh-client-interaction-frontends/fh-label';
import { TranslateModule } from '@ngx-translate/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FhLabelModule, TranslateModule, InputSwitchModule, ReactiveFormsModule, FormsModule],
  declarations: [FhInputSwitchComponent],
  exports: [FhInputSwitchComponent]
})
export class FhInputSwitchModule {}
